import { render } from "./tafrihatvavarzeshha.vue?vue&type=template&id=6e4ad548"
import script from "./tafrihatvavarzeshha.vue?vue&type=script&lang=js"
export * from "./tafrihatvavarzeshha.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/pamenar-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__